export const LAYOUT_ROUTES = {
    Calendar: 'calendar',
    Dashboard: 'dashboard',
    StockCount: 'stock-count',
    ControlCenter: 'control-center',
    Reports: 'reports',
    Messages: 'messages',
    SystemAdmin: 'system-admin'
};
